import { render } from "./manualCampaignDetailsDialog.vue?vue&type=template&id=c962941a&scoped=true"
import script from "./manualCampaignDetailsDialog.vue?vue&type=script&lang=js"
export * from "./manualCampaignDetailsDialog.vue?vue&type=script&lang=js"

import "./manualCampaignDetailsDialog.vue?vue&type=style&index=0&id=c962941a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c962941a"]])

export default __exports__